import { AsyncState, Updater, unloadedAsyncState } from 'widgets-for-react';
import { loadCreateCollection, loadEditCollection } from './collectionEditorApi';

export type CollectionEditorState = {
  editingState: AsyncState<string | {}>
} & ({ opened: false } | { opened: true; name: string; description: string })

export const initialCollectionEditorState: CollectionEditorState = {
  opened: false,
  editingState: unloadedAsyncState(),
}

export const collectionEditorStateUpdaters = {
  startEditingUpdater:
    (name: string, description: string) =>
    (
      state: CollectionEditorState
    ): CollectionEditorState & { hideOuterModal: boolean } => ({
      ...state,
      opened: true,
      name: name,
      description: description,
      editingState: unloadedAsyncState(),
      hideOuterModal: false,
    }),
  stopEditingUpdater:
    (hideOuterModal: boolean) =>
    (
      state: CollectionEditorState
    ): CollectionEditorState & { hideOuterModal: boolean } => ({
      ...state,
      opened: false,
      hideOuterModal: hideOuterModal,
    }),
  collectionNameUpdater:
    (update: string) =>
    (
      state: CollectionEditorState
    ): CollectionEditorState & { hideOuterModal: boolean } => ({
      ...(state.opened ? { ...state, name: update } : state),
      hideOuterModal: false,
    }),
  collectionDescriptionUpdater:
    (update: string) =>
    (
      state: CollectionEditorState
    ): CollectionEditorState & { hideOuterModal: boolean } => ({
      ...(state.opened ? { ...state, description: update } : state),
      hideOuterModal: false,
    }),
  startLoadingEditingStateUpdater:
    (collectionId: string | undefined) =>
    (
      state: CollectionEditorState
    ): CollectionEditorState & { hideOuterModal: boolean } => ({
      ...(state.opened
        ? {
            ...state,
            editingState:
              collectionId == undefined
                ? loadCreateCollection(state.name, state.description)
                : loadEditCollection(
                    collectionId,
                    state.name,
                    state.description
                  ),
          }
        : state),
      hideOuterModal: false,
    }),
  editingStateUpdater:
    (isNested: boolean) =>
    (updater: Updater<AsyncState<string | {}>>) =>
    (
      state: CollectionEditorState
    ): CollectionEditorState & {
      hideOuterModal: boolean
      reloadCollections: boolean
    } => {
      if (state.opened) {
        const newState = updater(state.editingState)
        const toLoadedUpdate =
          state.editingState.kind != 'loaded' && newState.kind == 'loaded'
        return toLoadedUpdate
          ? {
              ...collectionEditorStateUpdaters.stopEditingUpdater(!isNested)(
                state
              ),
              editingState: newState,
              reloadCollections: true,
            }
          : {
              ...state,
              editingState: newState,
              reloadCollections: false,
              hideOuterModal: false,
            }
      } else
        return { ...state, hideOuterModal: false, reloadCollections: false }
    },
}
